import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";

import {
  getSimpleAsideRoutes
} from '@/common/util'


Vue.use(VueRouter);

/** 注意： meta  key 一旦确定不可修改 且 同级唯一。 是作为识别这个对象的唯一标识！！！   */

// 旧有用户管理
export const userOldManageRoutes = [
  {
    path: "/oldUserList",
    name: "oldUserList",
    meta: {
      title: "麦力士用户列表",
      key: 'old-user-list',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/userOldManage/userList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userOldManage" */ "../views/userOldManage/userList.vue"),
  },
  {
    path: "/oldNo8UserList",
    name: "oldNo8UserList",
    meta: {
      title: "8号玩家用户列表",
      key: 'old-no8-user-list',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/userOldManage/no8UserList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userOldManage" */ "../views/userOldManage/no8UserList.vue"),
  },
  {
    path: "/oldBallRoomList",
    name: "oldBallRoomList",
    meta: {
      title: "旧有球房列表",
      key: 'old-ball-room-list',
      asideHidden: true, // 侧边栏显示
      pageApisPrm: import("../views/userOldManage/ballRoomList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>


      import(/* webpackChunkName: "userOldManage" */ "../views/userOldManage/ballRoomList.vue"),
  },
  // deviceChildList
  {
    path: "/oldDeviceList",
    name: "oldDeviceList",
    meta: {
      title: "旧有设备列表",// 侧边栏显示
      key: 'old-device-list',
      asideHidden: true,
      pageApisPrm: import("../views/userOldManage/deviceList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userOldManage" */ "../views/userOldManage/deviceList.vue"),
  },
]

// 用户管理
export const userManageRoutes = [
  {
    // platformPosterManage
    path: "/platformPosterManage",
    name: "platformPosterManage",
    meta: {
      title: "平台海报",
      key: 'platform-poster-manage',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/userManage/platformPosterManage.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "../views/userManage/platformPosterManage.vue"),
  },

  {
    // merchantPosterManage
    path: "/merchantPosterManage",
    name: "merchantPosterManage",
    meta: {
      title: "海报管理",
      key: 'merchant-poster-manage',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/userManage/merchantPosterManage.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "../views/userManage/merchantPosterManage.vue"),

  },
  // merchantNoticeManage
  {
    path: "/merchantNoticeManage",
    name: "merchantNoticeManage",
    meta: {
      title: "公告管理",
      key: 'merchant-notice-manage',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/userManage/merchantNoticeManage.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "../views/userManage/merchantNoticeManage.vue"),

  },
  {
    path: "/ballRoomList",
    name: "ballRoomList",
    meta: {
      title: "球房列表",
      key: 'ball-room-list',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/userManage/ballRoomList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>


      import(/* webpackChunkName: "userManage" */ "../views/userManage/ballRoomList.vue"),
  },
  // deviceChildList
  {
    path: "/deviceList",
    name: "deviceList",
    meta: {
      title: "设备列表", 
      key: 'device-list',
      asideHidden: true, // 侧边栏显示
      pageApisPrm: import("../views/userManage/deviceList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "../views/userManage/deviceList.vue"),
  },

  // blueToothList
  {
    path: "/blueToothList",
    name: "blueToothList",
    meta: {
      title: "蓝牙开关列表", 
      key: 'blue-tooth-list',
      asideHidden: true, // 侧边栏显示
      pageApisPrm: import("../views/userManage/blueToothList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "../views/userManage/blueToothList.vue"),
  },
  {
    path: "/roleVoiceManage",
    name: "roleVoiceManage",
    meta: {
      title: "角色语音管理",
      key: 'role-voice-manage',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/userManage/roleVoiceManage.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "../views/userManage/roleVoiceManage.vue"),
  },
  // lightTheme
  {
    path: "/lightTheme",
    name: "lightTheme",
    meta: {
      title: "灯光主题",
      key: 'light-theme',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/userManage/lightTheme.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "../views/userManage/lightTheme.vue"),
  },
  {
    path: "/soundEffectTheme",
    name: "soundEffectTheme",
    meta: {
      title: "音效主题",
      key: 'sound-effect-theme',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/userManage/soundEffectTheme.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
        import(/* webpackChunkName: "userManage" */ "../views/userManage/soundEffectTheme.vue"),
  },
  {
    path: "/soundEffectPack",
    name: "soundEffectPack",
    meta: {
      title: "音效包管理",
      key: 'sound-effect-pack',
      asideHidden: true, // 侧边栏显示
      pageApisPrm: import("../views/userManage/soundEffectPack.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
        import(/* webpackChunkName: "userManage" */ "../views/userManage/soundEffectPack.vue"),
  },
  // {
  //   path: "/userList",
  //   name: "userList",
  //   meta: {
  //     title: "麦力士用户列表",
  //     key: 'user-list',
  //     asideHidden: false, // 侧边栏显示
  //     pageApisPrm: import("../views/userManage/userList.vue").then(({ pageApiList }: any) => pageApiList)
  //   },
  //   component: () =>
  //     import(/* webpackChunkName: "userManage" */ "../views/userManage/userList.vue"),
  // },
  // {
  //   path: "/no8UserList",
  //   name: "no8UserList",
  //   meta: {
  //     title: "8号玩家用户列表",
  //     key: 'no8-user-list',
  //     asideHidden: false, // 侧边栏显示
  //     pageApisPrm: import("../views/userManage/no8UserList.vue").then(({ pageApiList }: any) => pageApiList)
  //   },
  //   component: () =>
  //     import(/* webpackChunkName: "userManage" */ "../views/userManage/no8UserList.vue"),
  // },
  
]

// 设备管理
// export const deviceManageRoutes = [
//   {
//     path: "/deviceManageList",
//     name: "deviceManageList",
//     meta: {
//       title: "设备管理",
//       key: 'device-manage-list',
//       asideHidden: false, // 侧边栏显示
//       pageApisPrm: import("../views/deviceManage/deviceList.vue").then(({ pageApiList }: any) => pageApiList)
//     },
//     component: () =>
//       import(/* webpackChunkName: "deviceManage" */ "../views/deviceManage/deviceList.vue"),
//   },
// ]

// // 硬件管理
// export const hardwareUpgradeRoutes = [
//   {
//     path: '/hardwareUpgradeList',
//     name: 'hardwareUpgradeList',
//     meta: {
//       title: "硬件升级",
//       key: 'hardware-upgrade-list',
//       asideHidden: false, // 侧边栏显示
//       pageApisPrm: import("../views/hardwareManage/hardwareUpgradeList.vue").then(({ pageApiList }: any) => pageApiList)
//     },
//     component: () =>
//       import(/* webpackChunkName: "hardwareManage" */ "../views/hardwareManage/hardwareUpgradeList.vue"),
//   }
// ]


/**
 *  之前项目的某一管理大类，
 * 当前项目暂时没有
 *
 */
function getMidLen() {
  // const dbRoutesLen = dataWholeBoardRoutes.length
  // console.log(dbRoutesLen, 'dbRoutesLen')

  // const mMRoutesLen = merchantManageRoutes.length
  // console.log(mMRoutesLen, 'mMRoutesLen')

  const uOMRoutesLen = userOldManageRoutes.length
  console.log(uOMRoutesLen, 'uOMRoutesLen')

  const uMRoutesLen = userManageRoutes.length
  console.log(uMRoutesLen, 'uMRoutesLen')

  // const dMRoutesLen = deviceManageRoutes.length
  // console.log(uMRoutesLen, 'uMRoutesLen')

  // const hwuMRoutesLen = hardwareUpgradeRoutes.length
  // console.log(hwuMRoutesLen, 'hwuMRoutesLen')

  // const oMRoutesLen = operationManageRoutes.length
  // console.log(oMRoutesLen, 'oMRoutesLen')

  // const fMRoutesLen = financeManageRoutes.length
  // console.log(fMRoutesLen, 'fMRoutesLen')

  // const aMRoutesLen = auditManageRoutes.length
  // console.log(aMRoutesLen, 'aMRoutesLen')

  // const oWMRoutesLen = officialWebManageRoutes.length
  // console.log(oWMRoutesLen, 'oWMRoutesLen')

  // const marMRoutesLen = marketManageRoutes.length
  // console.log(marMRoutesLen, 'marMRoutesLen')

  // const cMRoutesLen = couponManageRoutes.length
  // console.log(cMRoutesLen, 'cMRoutesLen')

  // const sOLRoutesLen = systemManageRoutes.length
  // console.log(sOLRoutesLen, 'sOLRoutesLen')

  const totalLen = uMRoutesLen

  console.log(totalLen, 'totalLen')

  return totalLen / 2
}

// console.log(getMidLen(), 'getMidLen')

export const asideRoutes = [
  ...userOldManageRoutes,
  ...userManageRoutes,
  // ...deviceManageRoutes,
  // ...hardwareUpgradeRoutes
]



const routes = [
  {
    path: "/",
    redirect: () => {
      const token = localStorage.getItem('token')

      if (token) {
        // const menusStr = localStorage.getItem('menus')

        const menus: any[] = getSimpleAsideRoutes()

        // console.log(menus, 'menus')

        const [
          fisrtRouteItem = {}
        ] = menus

        if (fisrtRouteItem.children instanceof Array) {
          const [child] = (fisrtRouteItem.children as any) || []

          return child.url || "/login";
        } else {
          return fisrtRouteItem.url || "/login"
        }
      } else {
        return "/login"
      }
    },
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
    },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      ...asideRoutes
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
